export default function HelloWidget({ name }) {
  return <p>Hello, {name}!</p>
}
